import { defineMessages } from "react-intl";

const messages = defineMessages({
  name: {
    defaultMessage: "Variant name",
    id: "J4E+jp",
  },
  sku: {
    defaultMessage: "SKU",
    id: "k4brJy",
  },
  channel: {
    defaultMessage: "Channels",
    id: "Vze3qI",
    description: "column category descriptor",
  },
  margin: {
    defaultMessage: "Margin",
    id: "Us9cA1",
    description: "profit margin",
  },
  price: {
    defaultMessage: "Price",
    id: "4hl9rS",
    description: "variant price in channel",
  },
  available: {
    defaultMessage: "Available",
    id: "BbP+k3",
    description: "variant availability in channel",
  },
  empty: {
    defaultMessage: "Use button above to add new product variants",
    id: "IH47ID",
  },
  warehouses: {
    defaultMessage: "Warehouses",
    id: "U5Da30",
  },
  attributes: {
    defaultMessage: "Attributes",
    id: "+xTpT1",
  },
  title: {
    defaultMessage: "Variants",
    id: "1WbTJ5",
    description: "product variants, title",
  },
  fullScreenTitle: {
    defaultMessage: "Variants for: {name}",
    id: "64aQXZ",
    description: "product variants, full-screen title",
  },
});

export default messages;
